import React, { useState } from 'react'
import Tabs from './Tabs'
import CardListTab from './CardListTab'
import HTag from '@/lib/HTag'
import clsx from 'clsx'

const TabbedCardList = ({ heading, items, accent }) => {
	const style =
		accent === '#FFC28B' ? 'bg-orange-light' :
		accent === '#FFC42F' ? 'bg-sunshine' :
		accent === '#E4F9FA' ? 'bg-light-blue' :
		accent === '#F7E9D4' ? 'bg-tan' :
		accent === '#0F2938' ? 'bg-grounding-navy text-white' :
		accent === '#7FC7C5' ? 'bg-caribbean' :
		'bg-orange text-white'

	const [$active, set$active] = useState(0)

	return (
		<section className={clsx('relative', style)}>
			<div className="section">

				<header className="text-center richtext">
					<HTag className="h1" {...heading} />
				</header>

				<Tabs state={[$active, set$active]} tabs={items} />

				{items?.map((item, key) => (
					<CardListTab {...item} hidden={key !== $active} key={key} />
				))}
			</div>
		</section>
	)
}

export default TabbedCardList
